import { render, staticRenderFns } from "./ReporteObra.vue?vue&type=template&id=5a1897ff&"
import script from "./ReporteObra.vue?vue&type=script&lang=js&"
export * from "./ReporteObra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports